'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nextBreakpoint = function nextBreakpoint(breakpoints, device) {
  var keys = Object.keys(breakpoints);
  var nextDevice = keys[keys.indexOf(devices.indexOf(device)) + 1];
  return breakpoints[nextDevice];
};

var devices = ['mobile', 'tablet', 'desktop'];

var calcPixel = function calcPixel(px) {
  return "".concat(parseFloat(px) - 0.02, "px");
};

var above = function above(device) {
  return function (_ref) {
    var breakpoints = _ref.theme.breakpoints;
    return "@media (min-width: ".concat(breakpoints[devices.indexOf(device)], ")");
  };
};
var below = function below(device) {
  return function (_ref2) {
    var breakpoints = _ref2.theme.breakpoints;
    return "@media (max-width: ".concat(calcPixel(breakpoints[devices.indexOf(device)]), ")");
  };
};
var between = function between(start, stop) {
  return function (_ref3) {
    var breakpoints = _ref3.theme.breakpoints;
    return "@media (min-width: ".concat(breakpoints[devices.indexOf(start)], ") and (max-width: ").concat(breakpoints[devices.indexOf(stop)], ")");
  };
};
var only = function only(device) {
  return function (_ref4) {
    var breakpoints = _ref4.theme.breakpoints;
    return "@media (min-width: ".concat(breakpoints[devices.indexOf(device)], ") ").concat(nextBreakpoint(breakpoints, device) ? "and (max-width: ".concat(calcPixel(nextBreakpoint(breakpoints, device)), ")") : '');
  };
};

exports.above = above;
exports.below = below;
exports.between = between;
exports.only = only;
